import React from 'react'
import HeroSection from '../../components/Home/HeroSection'
import WhoWeAre from '../../components/Home/WhoWeAre'
import RiseAboveSection from '../../components/Home/RiseAboveSection'
import CoreStrengthsSection from '../../components/Home/CoreStrengthsSection'
import CoreStrengthCards from '../../components/Home/CoreStrengthCards'
// import OurFleetSection from '../../components/Home/OurFleetSection'
import StackCard from '../../components/Home/StackCard'
import TestimonialCarousel from '../../components/Home/TestimonialCarousel'
import FadeInSectionDownToUp from '../../components/FadeAnimations/FadeInSectionDownToUp'
import ReadyToTakeOffSection from '../../components/Home/ReadyToTakeOffSection'
import ScrollableAircraftSection from '../../components/Fleet/ScrollableAircraftSection'

export default function Home() {
  return (
    <div>
      <div>
        <HeroSection />
      </div>
      <div>
        <WhoWeAre />
      </div>
      <div>
        <RiseAboveSection />
      </div>
      <div>
        <CoreStrengthsSection />
      </div>
      <div>
        <CoreStrengthCards />
      </div>
      {/* <div>
        <OurFleetSection />
      </div> */}
      <div>
        <div className='max-sm:hidden'>
          <ScrollableAircraftSection />
        </div>
        <div className='hidden max-sm:block'>
          <StackCard />
        </div>
      </div>
      <div>
        <TestimonialCarousel />
      </div>
      <div className='px-10 py-10 space-y-5'>
        <div>
          <FadeInSectionDownToUp>
            <div className='text-center'>
              <p className='text-[#012D6F] font-bold text-4xl'>Moments That Define</p>
              <p className='text-[#E43038] font-bold text-4xl'>Our Journey</p>
            </div>
          </FadeInSectionDownToUp>
        </div>
        <div>
          <FadeInSectionDownToUp>
            <img className='w-full' src='https://mhcockpit.com/Media/4%20Aviators/Home/gallery.jpg' alt='4 Aviators Gallery' />
          </FadeInSectionDownToUp>
        </div>
      </div>
      <div>
        <ReadyToTakeOffSection />
      </div>
    </div>
  )
}
